import { existsBy } from "neetocist";

const getSum = (data, searchKey) => {
  let sum = 0;
  for (const key in data) {
    if (key.includes(searchKey)) sum += data[key];
  }

  return sum;
};

export const transformInsights = (data, defaultItems) => {
  const othersData = Object.keys(data)
    .filter(key => !existsBy({ value: key }, defaultItems))
    .map(key => ({ name: key, value: data[key] }));

  const defaultData = defaultItems.map(({ label, value }) => ({
    name: label,
    value: getSum(data, value) || 0,
  }));

  return { defaultData, othersData };
};
